import React, { useEffect } from 'react';
import WorkPlanList from '../WorkPlanList';
import { workplanService } from '../../../../services/workplanService';
import { handleAPIErrors } from '../../../auxilaries';
import { connect } from 'react-redux';
import { updateArchivedWorkPlans, updateSpinnerShow, updateSnackbar, updateSettingsList, updateIsArchiveMode } from '../actions';

/**
 * WorkPlanArchives - Container Component
 *
 * This component is responsible for:
 * - Fetching archived workplans data from the API
 * - Fetching settings data from the API
 * - Managing loading and error states
 * - Passing data down to the presentational WorkPlanList component in archive mode
 *
 * This follows the Container/Presentational component pattern.
 */
function WorkPlanArchives({
	refreshAdmin,
	updateArchivedWorkPlans,
	updateSpinnerShow,
	updateSnackbar,
	updateSettingsList,
	updateIsArchiveMode,
	archivedWorkPlans,
	...props
}) {
	useEffect(() => {
		// Set archive mode in Redux state so WorkPlan component knows to disable actions
		updateIsArchiveMode(true);

		const fetchArchivedWorkplansData = async () => {
			updateSpinnerShow(true);
			try {
				let [resArchives, settingsList] = await Promise.all([
					workplanService.getArchivedWorkplans(),
					workplanService.getSettings()
				]);

				// Transform archived workplans data
				resArchives.data = resArchives.data.map(wp => {
					return {
						...wp,
						length: wp.periodLength * (wp.periodType === "Weeks" ? 7 : 1)
					};
				});

				// Transform settings data
				settingsList = settingsList.data.map(setting => {
					return { ...setting, value: setting.id, label: setting.name };
				});

				updateArchivedWorkPlans(resArchives.data);
				updateSettingsList(settingsList);
				updateSpinnerShow(false);
			} catch (ex) {
				let errorMessage = handleAPIErrors(ex.response);
				updateSnackbar({
					typeSnackbar: 'error',
					messageSnackbar: errorMessage,
					openSnackbar: true,
				});
				updateSpinnerShow(false);
			}
		};

		fetchArchivedWorkplansData();
	}, [updateArchivedWorkPlans, updateSpinnerShow, updateSnackbar, updateSettingsList, updateIsArchiveMode]);

	// Pass all data and props down to the presentational component in archive mode
	return (
		<WorkPlanList
			refreshAdmin={refreshAdmin}
			isArchiveMode={true}
			workPlans={archivedWorkPlans}
			updateWorkPlans={updateArchivedWorkPlans}
			{...props}
		/>
	);
}

const mapStateToProps = state => {
	return {
		archivedWorkPlans: state.archivedWorkPlans,
	};
};

const mapDispatchToProps = {
	updateSpinnerShow,
	updateArchivedWorkPlans,
	updateSnackbar,
	updateSettingsList,
	updateIsArchiveMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkPlanArchives);

